// TODO: remove this, the only reducer that is concerned about location
// is the `invites` reducer on the invites page
export const LOCATION_CHANGE = 'LOCATION_CHANGE';

export function changeLocation(location) {
  return { type: LOCATION_CHANGE, location };
}
